<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import Icon from "@iconify/svelte";
  export let editor;

  const dispatch = createEventDispatcher();
  let canUndo = false;
  let canRedo = false;

  const updateStates = () => {
    if (editor) {
      canUndo = editor.can().undo();
      canRedo = editor.can().redo();
    }
  };

  $: if (editor) {
    updateStates();
    editor.on("transaction", updateStates);
  }

  const addLink = () => {
    const url = window.prompt("URL");
    if (url) {
      editor.chain().focus().setLink({ href: url }).run();
    }
  };
</script>

<div class="menu-bar compact">
  {#if editor}
    <div class="menu-group essential-controls">
      <button
        on:click={() => editor.chain().focus().toggleBold().run()}
        class:active={editor?.isActive("bold")}
        title="Bold">
        <Icon icon="heroicons:bold" class="w-4 h-4" />
      </button>
      <button
        on:click={() => editor.chain().focus().toggleItalic().run()}
        class:active={editor?.isActive("italic")}
        title="Italic">
        <Icon icon="heroicons:italic" class="w-4 h-4" />
      </button>
      <button
        on:click={() => editor.chain().focus().toggleUnderline().run()}
        class:active={editor?.isActive("underline")}
        title="Underline">
        <Icon icon="heroicons:underline" class="w-4 h-4" />
      </button>
      <button on:click={() => editor.commands.undo()} disabled={!canUndo} title="Undo">
        <Icon icon="heroicons:arrow-uturn-left" class="w-4 h-4" />
      </button>
      <button on:click={() => editor.commands.redo()} disabled={!canRedo} title="Redo">
        <Icon icon="heroicons:arrow-uturn-right" class="w-4 h-4" />
      </button>
      <button on:click={addLink} class:active={editor?.isActive("link")} title="Add Link">
        <Icon icon="heroicons:link" class="w-4 h-4" />
      </button>
      <button
        on:click={() => editor.chain().focus().unsetLink().run()}
        disabled={!editor?.isActive("link")}
        title="Remove Link">
        <Icon icon="heroicons:link-slash" class="w-4 h-4" />
      </button>
    </div>
  {/if}
</div>

<style>
  .menu-bar.compact {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    gap: 8px;
    padding: 8px;
    border-bottom: 1px solid #ccc;
    background: #f5f5f5;
    max-width: 100%;
    box-sizing: border-box;
  }

  .menu-group {
    display: flex;
    gap: 4px;
    flex-wrap: nowrap;
    align-items: center;
  }

  .essential-controls {
    flex: 1;
    display: flex;
    gap: 4px;
  }

  .menu-toggle {
    margin-left: auto;
    padding-left: 8px;
    border-left: 1px solid #ddd;
  }

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    min-width: 24px;
    height: 24px;
    white-space: nowrap;
  }

  button:hover {
    background: #f0f0f0;
  }

  button.active {
    background: #e0e0e0;
  }
</style>
